import React, { type FC } from 'react';
import { styled } from '@compiled/react';
import { token, type CSSToken } from '@atlaskit/tokens';
import type { MainContainerProps } from './types.tsx';

export const MainContainer: FC<MainContainerProps> = ({ children, ...props }) => {
	return <StyledMainContainer {...props}>{children}</StyledMainContainer>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledMainContainer = styled.div<{
	tableBorderRadius?: CSSToken;
	tableBorderWidth?: string;
}>({
	display: 'flex',
	flexFlow: 'column nowrap',
	borderColor: token('color.border'),
	borderStyle: 'solid',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	borderWidth: `${(props: { tableBorderWidth?: CSSToken }) => props.tableBorderWidth}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	borderRadius: `${(props: { tableBorderRadius?: CSSToken }) => props.tableBorderRadius ?? token('radius.large')}`,
	overflow: 'hidden',
	position: 'static',
});
